import type { SVGProps } from "react";

export function IconBlueMoneyBag(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_10127_1488)">
        <path
          d="M4.1922 12.1776L9 7L6.75 3H17.25L15 7L19.8078 12.1776C22.9271 15.5368 20.5448 21 15.9606 21H8.03936C3.45525 21 1.07293 15.5368 4.1922 12.1776Z"
          fill="#5486FA"
          stroke="#5486FA"
          strokeWidth="1.5"
          strokeLinecap="square"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.8441 5.25H12.7492H11.2492H7.1543L7.99805 6.75H11.2492V10.75H12.7492V6.75H16.0003L16.8441 5.25Z"
          fill="#0B0D17"
        />
      </g>
      <defs>
        <clipPath id="clip0_10127_1488">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
